import ApiResponse from "../models/ApiResponse";
import axios from "./axios-instance";

export const getAINotesSummary = async (userId: number, notes: string): Promise<ApiResponse<string>> => {
    try {
        const response = await axios.post('/ai/notes/summary/' + userId, notes);
        return {
            data: response.data,
            status: response.status
        };
    } catch (err: any) {
        console.error('Failed to get AI notes summary: ', err);
        return {
            data: null,
            status: err.status
        };
    }
}